/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
import { AbstractControl, NG_VALIDATORS, Validator } from '@angular/forms';
import { Directive } from '@angular/core';

@Directive({
    selector: '[appComplexPasswordValidator]',
    providers: [{ provide: NG_VALIDATORS, useExisting: ComplexPasswordValidationDirective, multi: true }]
})

/**
 * @name ComplexPasswordValidationDirective
 * @description
 * ## Validation rules:
 * - password must be at least 8 characters long.
 * - contain 1 or more uppercase.
 * - contain 1 or more numeric.
 * - contain 1 or more lowercase.
 * - contain at least one special character, special characters can include !@#$%^&£?*-
 * @see {@link https://regex101.com/r/F1gzBr/1}
 *
 * ## Further reading
 * ### Browser specific password guidelines
 * - Apple/Safari {@link https://support.apple.com/en-gb/guide/security/secc84c811c4/1/web/1}
 * - Mozilla/Firefox {@link https://support.mozilla.org/en-US/kb/password-strength}
 * - Google/Chrome {@link https://guidebooks.google.com/online-security/protect-your-google-account/create-strong-password?hl=en}
 * - Microsoft/Edge {@link https://support.microsoft.com/en-gb/windows/create-and-use-strong-passwords-c5cebb49-8c53-4f5e-2bc4-fe357ca048eb}
 *
 * ### NIST (National Institute of Standards and Technology)
 * #### 800-63-3 Digital Identity Guidelines:
 * @see {@link https://pages.nist.gov/800-63-3/sp800-63-3.html}
 */
export class ComplexPasswordValidationDirective implements Validator {
    public validate(control: AbstractControl): { [key: string]: any } | null {
        return complexPasswordValidation(control);
    }
}

/**
 * Complex password validation.
 * @param control
 * @returns {any}
 */
export function complexPasswordValidation(control: any): any {
    const regex: RegExp = /(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&£?*-]).{8,128}/g;

    return (!control?.value || regex.test(control?.value)) ? null : {
        'passwordValidation': 'invalid_password_complex'
    };
}
